import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { FontWithOutline } from "../../generic/font-with-outline/FontWithOutline";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
export var ResourceCost = function (props) {
    var ownedAmount = props.ownedAmount, amount = props.amount, id = props.id;
    var requirementClass = ownedAmount.greaterThanOrEqual(amount)
        ? IdStyles.TextPositive
        : IdStyles.TextNegative;
    var ownedAmountDisplay = (React.createElement(React.Fragment, null,
        React.createElement(NumberFormat, { amount: ownedAmount, format: TypeNumberFormat.None }),
        "/"));
    var showOwnedAmount = id !== IdResource.Money && id !== IdResource.Gold;
    return (React.createElement("div", { className: "flex flex--guts flex--stacked" },
        React.createElement(ResourceIcon, { resource: props, styleId: IdStyles.IconExtraLarge, tooltipVerticalAdjust: IdTooltipAdjust.Large }),
        React.createElement(FontWithOutline, { style: requirementClass },
            showOwnedAmount && ownedAmountDisplay,
            React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.None }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/resource/ResourceCost.tsx
// module id = 2255
// module chunks = 3